import { FaRegCheckCircle } from "react-icons/fa";
import { NavLink } from "react-router-dom";

export const homeBannerContent = (
  <div className='space-y-3 sm:space-y-4 xl:space-y-5 2xl:space-y-6'>

    <div className='
             font-extrabold
             text-2xl
            sm:text-4xl
            md:text-5xl 
            xl:text-6xl
            2xl:text-7xl
      '>
      YOUR AFFORDABLE FAMILY HEALTH
      INSURANCE MARKETPLACE
    </div>

    <div className='
            text-base text-secondary underline font-bold
            sm:text-lg
            xl:text-xl
      '>
      $0 Deductible and $0 Co-Pay Plans Available
    </div>

    <ul className='text-sm sm:text-base xl:text-lg'>
      <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 md:mx-2 text-secondary' /> Find more health insurance options</li>
      <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 md:mx-2 text-secondary' /> Individual, family, and small business insurance</li>
      <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 md:mx-2 text-secondary' /> Up to 50% less on health insurance premiums</li>
    </ul>

    <div className='text-base sm:text-lg xl:text-xl font-bold'>
      Find the Best Health Insurance Coverage in Your State! Ask for A Free Quote Today
    </div>

    <div className='
            flex flex-col space-y-2
            sm:flex-row sm:space-y-0 sm:space-x-4
            items-center
      '>
      <NavLink to='/online-quotes'>
        <button className='
                  btn btn-md btn-secondary text-neutral-content font-bold border-white border-2
                  sm:btn-lg sm:btn-wide
        '>
          Online Quote
        </button>
      </NavLink>

      <NavLink to='/group-health'>
        <button className='
                  btn btn-md btn-secondary text-neutral-content font-bold border-white border-2
                  sm:btn-lg sm:btn-wide
        '>
          Group Health Quote
        </button>
      </NavLink>
    </div>
  </div >
)